import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as forge from 'node-forge';

import { AppService } from '../../services/app.service';
import { Lang } from '../../model/orm/lang.model';

const PUBLIC_KEY_PEM = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA9d+xII1nk5VdAdQ1xND2
cpFh0CTtQf9XUkRccl1vEEW0Fgrds5zgSNItzXM6zLjpGbgw6R2VjDLhB192sZ1T
lADV/PRrN2yNjzoiWEj/8YInuLV9By1nm06nfYbUjeGWwgwf/WvkQemXU0yhZNZL
yTC2KMaZfO9w53HVBkP/k+/zBJbHNERb1FTCSaMIS+PKU7SpgbO8NPQIEE2W2GWS
Xa7+hK5vugtSYPqIlNSq4FmNsw+xEJ87d2zoLFu+bjR2tYgx7UtNiYu9wblH8jqO
D7rn3+/6P86sxM6dkfQTTJMM7yvsJYuw+edIRY4d6n9GLH/2GDMH30hJxsEY5fo5
KQIDAQAB
-----END PUBLIC KEY-----`;

@Component({
    selector: 'email-welcome-page',
    templateUrl: './email-welcome.page.html',
    styleUrls: ['./email-welcome.page.scss']
})
export class EmailWelcomePage implements OnInit {
    public email: string = '';
    public loading: boolean = true;
    public error: boolean = false;

    constructor(
        private appService: AppService,
        private route: ActivatedRoute,
    ) {}

    get currentLang(): Lang {
        return this.appService.currentLang.value;
    }

    public ngOnInit(): void {
        this.appService.headerAlwaysOpaque = true;
        this.appService.catmenumobileActive = false;
        this.appService.collmenumobileActive = false;
        this.appService.setTitle('Welcome - Friends of Fashion');

        if (this.appService.isBrowser) {
            this.route.queryParams.subscribe(params => {
                const token = params['token'];
                if (token) {
                  // console.log(token, 'token');
                    this.decryptToken(token);
                } else {
                    this.loading = false;
                    this.error = true;
                }
            });
        } else {
            this.loading = false;
        }
    }

    private decryptToken(token: string): void {
        try {
            const base64 = token.replace(/-/g, '+').replace(/_/g, '/');
            const binary = atob(base64);
            const bytes = new Uint8Array(binary.length);
            for (let i = 0; i < binary.length; i++) {
                bytes[i] = binary.charCodeAt(i);
            }

            const publicKey = forge.pki.publicKeyFromPem(PUBLIC_KEY_PEM);
            const decrypted = (publicKey as any).encrypt(
                forge.util.binary.raw.encode(bytes), 'RAW', false
            );
            const jsonStart = decrypted.indexOf('{');
            const jsonString = decrypted.substring(jsonStart);
            const data = JSON.parse(jsonString);
            this.email = data.email || '';
            this.loading = false;
        } catch (e) {
            this.loading = false;
            this.error = true;
        }
    }
}
